import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {MatchEventsModuleController} from "../match-events-module.controller";

export class MatchEventsModuleProps extends BaseModuleProps {
  controller: MatchEventsModuleController;
  alwaysShowStages: Boolean;
  gameId: Number;
}
